// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-toolbar__title[data-v-56d45b60]{overflow:visible;display:flex}[data-v-56d45b60] .v-toolbar__content{padding:4px 0}", ""]);
// Exports
module.exports = exports;
